import React from 'react'
import styles from './DonutChart.module.scss'
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from 'recharts'
import cx from 'classnames'

const themes = [
  {
    graph: ['#C2DBE7', '#0D9FCC'],
    label: '#016787',
    pill: '#2187A7',
  },
  {
    graph: ['#B9E4DA', '#4B9483'],
    label: '#3B8473',
    pill: '#4B9483',
  },
]

const CustomLabel = ({ viewBox, value, scoreLabel, theme }) => {
  return (
    <g>
      <text
        x={viewBox.cx}
        y={viewBox.cy}
        textAnchor="middle"
        dominantBaseline="central"
        alignmentBaseline="middle"
        className={cx('recharts-text recharts-label', {
          [styles.label]: true,
        })}
        style={{ fill: theme.label }}
      >
        {scoreLabel}
      </text>
    </g>
  )
}

export const DonutChart = ({ value, scoreLabel, isGreen = false }) => {
  const data01 = [
    { name: 'value', value: value },
    { name: 'empty space', value: 100 - value },
  ]

  const theme = themes[Number(isGreen)]

  return (
    <div className={styles.donutChart}>
      <ResponsiveContainer className={styles.responsiveContainer}>
        <PieChart className={styles.background}>
          <Pie
            data={[{ name: 'value', value: 100 }]}
            dataKey="value"
            cx={78}
            cy={78}
            innerRadius={58}
            outerRadius={78}
            cornerRadius={10}
            isAnimationActive={false}
          >
            <Cell fill={'#f5f5f5'} />
          </Pie>
        </PieChart>
        <PieChart>
          <defs>
            <linearGradient id={`myGradient${isGreen}`}>
              <stop offset="0%" stopColor={theme.graph[0]} />
              <stop offset="100%" stopColor={theme.graph[1]} />
            </linearGradient>
          </defs>
          <Pie
            data={data01}
            dataKey="value"
            cx={78}
            cy={78}
            innerRadius={58}
            outerRadius={78}
            cornerRadius={10}
          >
            {data01.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index ? 'transparent' : `url(#myGradient${isGreen})`}
                className={index ? styles.hiddenCell : undefined}
              />
            ))}
            <Label
              content={
                <CustomLabel
                  scoreLabel={scoreLabel}
                  value={value}
                  theme={theme}
                />
              }
              position="center"
            />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
